import React from 'react'

import Box from 'components/_new/layout/Box/Box'
import Button from 'components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './Error.scss'


const Error = ({ onEdit }) => (
  <Box className={s.error} mt="8">
    <Box pr="12">
      <Text className={s.errorText} message={messages.text} color="black" />
    </Box>
    <Button
      className={s.action}
      title={messages.editAddress}
      weight="normal"
      color="brand"
      size="sm"
      uppercase
      onClick={onEdit}
    />
  </Box>
)


export default Error
